import * as docx from "docx";
import {
  AlignmentType,
  BorderStyle,
  Header,
  HorizontalPositionAlign,
  HorizontalPositionRelativeFrom,
  ImageRun,
  Paragraph,
  TextRun,
  VerticalAlign,
  VerticalPositionAlign,
  VerticalPositionRelativeFrom,
} from "docx";
import { formatMoney, truncateList } from "../../../util";
import { logoBase64, tickBase64 } from "../base64";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import saveAs from "file-saver";
import { CreateNotification } from "../../../../../components/notifier";

export const exportRepairTicket = (item: any) => {
  const arr: any = item.eContent ? JSON.parse(item.eContent) : [];

  const TableMargins = {
    top: 150,
    bottom: 100,
    left: 50,
    right: 50,
  };

  const getTitle = (string: string) => {
    const myArray = string.split("-");
    return myArray[1].trim();
  };

  const tableRows = arr.map((e: any) => {
    return new docx.TableRow({
      children: [
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: (e.id - 1).toString(),
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 500, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.NameSupplies || "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 3000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.Unit || "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 3000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.Amount + "" || "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 2000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.UnitPrice ? formatMoney(e.UnitPrice) : "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 2000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.Plan || "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 1000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.IntoMoney ? formatMoney(e.IntoMoney) : "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 2000, type: docx.WidthType.DXA },
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              children: [
                new docx.TextRun({
                  text: e.Notes || "",
                  size: 22,
                }),
              ],
              alignment: docx.AlignmentType.CENTER,
            }),
          ],
          margins: TableMargins,
          width: { size: 3000, type: docx.WidthType.DXA },
        }),
      ],
    });
  });
  const doc = new docx.Document({
    sections: [
      {
        headers: {
          default: new Header({
            children: [
              new docx.Table({
                rows: [
                  new docx.TableRow({
                    children: [
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new ImageRun({
                                data: logoBase64,
                                transformation: {
                                  width: 100,
                                  height: 30,
                                },
                                floating: {
                                  zIndex: 5,
                                  horizontalPosition: {
                                    relative: HorizontalPositionRelativeFrom.PAGE,
                                    align: HorizontalPositionAlign.CENTER,
                                  },
                                  verticalPosition: {
                                    relative: VerticalPositionRelativeFrom.PAGE,
                                    align: VerticalPositionAlign.CENTER,
                                  },
                                },
                              }),
                            ],
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: TableMargins,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new TextRun({
                                text: "PHIẾU KIỂM TRA VÀ SỬA CHỮA THIẾT BỊ CNTT",
                                bold: true,
                                size: 26,
                                color: "000000",
                              }),
                            ],
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        width: { size: 5000, type: docx.WidthType.DXA },
                        margins: TableMargins,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new docx.TableCell({
                        children: [
                          new Paragraph({ text: "Mã số: BM/CNTT/04" }),
                          new Paragraph({ text: "Lần ban hành: 01" }),
                          new Paragraph({
                            text: "Ngày hiệu lực: 15/02/2023",
                          }),
                        ],

                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: TableMargins,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ],
                    height: { value: 1000, rule: docx.HeightRule.EXACT },
                    cantSplit: true,
                  }),
                ],
                margins: {
                  bottom: 50,
                },
              }),
            ],
          }),
        },
        properties: {
          page: {
            margin: {
              top: 1134,
              right: 850,
              bottom: 1134,
              left: 1134,
            },
          },
        },
        children: [
          new docx.Table({
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: `Phiếu số: ${item.id}`,
                            color: "000000",
                            size: 24,
                            italics: true,
                          }),
                        ],
                        indent: {
                          right: 50,
                        },
                        alignment: docx.AlignmentType.RIGHT,
                      }),
                    ],
                    margins: { top: 200 },
                    borders: {
                      top: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                      bottom: {
                        style: BorderStyle.NONE,
                      },
                      left: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                      right: {
                        style: BorderStyle.NONE,
                        color: "ffffff",
                      },
                    },
                  }),
                ],
              }),
            ],
          }),
          new docx.Table({
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "I. Thông tin thiết bị",
                            size: 26,
                            color: "000000",
                            bold: true,
                          }),
                        ],
                        spacing: {
                          after: 70,
                        },
                      }),
                      new docx.Table({
                        rows: [
                          new docx.TableRow({
                            children: [
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Loại thiết bị: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: `${getTitle(item.Title)}`,
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Mã TS/CC: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: item.ECodeTCSSId || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Ngày hỏng: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: getDDMMYYYFormat(item.eBrokenDate) || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Nguyên giá: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        // text: item.eCost + "" || '',
                                        text: "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Số lần sửa trong năm: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Độ ưu tiên: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: item.ePriority || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                ],
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.NONE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  right: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  left: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                                width: {
                                  size: 4800,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Cơ quan/Đơn vị: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: item.eDepartment || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Đơn vị/Phòng: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: item.eUnitRoom || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Vị trí thiết bị: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: item.eDeviceLocation || "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Ngày tăng: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: truncateList(item.eDayOfIncrease?.split(";")),
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),

                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Giá trị còn lại: `,
                                        size: 24,
                                        bold: true,
                                      }),
                                      new TextRun({
                                        text: "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 60,
                                    },
                                  }),
                                  new docx.Paragraph({
                                    children: [
                                      new TextRun({
                                        text: `Lần sửa gần nhất: `,
                                        bold: true,
                                        size: 24,
                                      }),
                                      // new TextRun({
                                      //   text: truncateList(item.eLastEdit?.split(';').filter((value: string) => !!value.trim())),
                                      //   size: 24
                                      // }),
                                      new TextRun({
                                        text: "",
                                        size: 24,
                                      }),
                                    ],
                                    indent: {
                                      left: 200,
                                    },
                                    spacing: {
                                      before: 60,
                                      after: 20,
                                    },
                                  }),
                                ],
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.NONE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  right: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  left: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                              }),
                            ],
                          }),
                        ],
                        borders: {
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 1,
                            color: "FFFFFF",
                          },
                        },
                      }),
                    ],
                    width: { size: 11000, type: docx.WidthType.DXA },
                    margins: {
                      top: 100,
                      left: 100,
                      right: 100,
                      // bottom: 100,
                    },
                    verticalAlign: VerticalAlign.CENTER,
                    borders: {
                      bottom: {
                        style: BorderStyle.NONE,
                        size: 1,
                        color: "FFFFFF",
                      },
                    },
                  }),
                ],
                cantSplit: true,
                tableHeader: true,
                height: { value: 1000, rule: docx.HeightRule.AUTO },
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: `Hiện tượng hỏng: `,
                            size: 24,
                            bold: true,
                          }),
                          new TextRun({
                            text: item.eCorruptedSymptoms || "",
                            size: 24,
                          }),
                        ],
                        indent: {
                          left: 274,
                        },
                        // spacing: {
                        //   before: 60,
                        //   after: 60,
                        // }
                      }),
                    ],
                    borders: {
                      top: {
                        style: BorderStyle.NONE,
                        size: 0,
                        color: "FFFFFF",
                      },
                    },
                  }),
                ],
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "II. Đội CNTT chuẩn đoán nguyên nhân",
                            size: 26,
                            color: "000000",
                            bold: true,
                          }),
                        ],
                      }),
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: `Nguyên nhân: `,
                            size: 24,
                            bold: true,
                            color: "000000",
                          }),
                          new TextRun({
                            text: item.eCause || "",
                            size: 24,
                            color: "000000",
                          }),
                        ],
                        indent: {
                          left: 200,
                        },
                        spacing: {
                          before: 100,
                        },
                      }),
                    ],
                    margins: TableMargins,
                  }),
                ],
                cantSplit: true,
                height: { value: 1000, rule: docx.HeightRule.AUTO },
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "III. Phương án sửa chữa đề xuất: ",
                            size: 26,
                            color: "000000",
                            bold: true,
                          }),
                          new TextRun({
                            text: item.eRepair || "",
                            size: 24,
                            color: "000000",
                          }),
                        ],
                        spacing: {
                          before: 100,
                          after: 50,
                        },
                        indent: {
                          left: 100,
                        },
                      }),
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "(Danh mục vật tư quá nhiều sẽ được đính kèm riêng, vật tư mua ngoài có báo giá đính kèm)",
                            size: 20,
                            italics: true,
                          }),
                        ],
                        spacing: {
                          after: 50,
                        },
                        indent: {
                          left: 100,
                        },
                      }),
                      new docx.Table({
                        rows: [
                          new docx.TableRow({
                            children: [
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "STT",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 500,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Tên vật tư",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 12000,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Đơn vị tính",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 200,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Số lượng",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 300,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Đơn giá",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 300,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Nguồn vật tư",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 500,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Thành tiền",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 500,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new docx.Paragraph({
                                    children: [
                                      new docx.TextRun({
                                        text: "Ghi chú",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 3000,
                                  type: docx.WidthType.DXA,
                                },
                              }),
                            ],
                          }),
                          ...tableRows,
                        ],
                        borders: {
                          left: {
                            style: BorderStyle.NONE,
                            size: 1,
                            color: "ffffff",
                          },
                          bottom: {
                            style: BorderStyle.NONE,
                            size: 1,
                            color: "ffffff",
                          },
                          right: {
                            style: BorderStyle.NONE,
                            size: 1,
                            color: "ffffff",
                          },
                        },
                      }),
                    ],
                  }),
                ],
                cantSplit: true,
                height: { value: 5000, rule: docx.HeightRule.AUTO },
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Table({
                        rows: [
                          new docx.TableRow({
                            children: [
                              new docx.TableCell({
                                children: [
                                  new Paragraph({
                                    children: [
                                      new TextRun({
                                        text: "Chuyên viên CNTT",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                    border: {
                                      bottom: {
                                        style: BorderStyle.SINGLE,
                                        size: 1,
                                        color: "000000",
                                      },
                                    },
                                  }),
                                  new Paragraph({
                                    text: item.eCreatedDate
                                      ? `Ngày tạo: ${getDDMMYYYFormat(item.eCreatedDate)} - ${getHHmmFormat(
                                          item.eCreatedDate
                                        )}`
                                      : `Ngày tạo: ${getDDMMYYYFormat(item.createdDateTime)} - ${getHHmmFormat(
                                          item.createdDateTime
                                        )}`,
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  new Paragraph({
                                    text: item.ePhoneNumber ? item.ePhoneNumber : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  item.createdDateTime &&
                                    // new docx.Paragraph({
                                    //   children: [
                                    //     new ImageRun({
                                    //       data: imageTick,
                                    //       transformation: {
                                    //         width: 60,
                                    //         height: 60,
                                    //       },
                                    //     }),
                                    //   ],
                                    //   spacing: { before: 30 },
                                    //   alignment: docx.AlignmentType.CENTER,
                                    // }),
                                    new Paragraph({
                                      children: [
                                        new TextRun({
                                          text: item.eCreateName
                                            ? item.eCreateName
                                            : item.createdBy.user.displayName,
                                          break: 3,
                                        }),
                                      ],
                                      alignment: docx.AlignmentType.CENTER,
                                      spacing: { before: 90 },
                                    }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 5500,
                                  type: docx.WidthType.DXA,
                                },
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  left: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                              }),

                              new docx.TableCell({
                                children: [
                                  new Paragraph({
                                    children: [
                                      new TextRun({
                                        text: "Cán bộ CNTT",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                    border: {
                                      bottom: {
                                        style: BorderStyle.SINGLE,
                                        size: 1,
                                        color: "000000",
                                      },
                                    },
                                  }),
                                  new Paragraph({
                                    text: item.eApprovedDate
                                      ? `Ngày duyệt: ${getDDMMYYYFormat(item.eApprovedDate)} - ${getHHmmFormat(
                                          item.eApprovedDate
                                        )}`
                                      : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  new Paragraph({
                                    text:
                                      item.eApprovedBy && item.eApprovedDate
                                        ? item.eApprovedBy.split("|")[2]
                                        : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  item.eApprovedDate &&
                                    // new docx.Paragraph({
                                    //   children: [
                                    //     new ImageRun({
                                    //       data: imageTick,
                                    //       transformation: {
                                    //         width: 60,
                                    //         height: 60,
                                    //       },
                                    //     }),
                                    //   ],
                                    //   spacing: { before: 50 },
                                    //   alignment: docx.AlignmentType.CENTER,
                                    // }),
                                    new Paragraph({
                                      children: [
                                        new TextRun({
                                          text:
                                            item.eApprovedBy && item.eApprovedDate
                                              ? item.eApprovedBy.split("|")[1]
                                              : "",
                                          break: 3,
                                        }),
                                      ],
                                      alignment: docx.AlignmentType.CENTER,
                                      spacing: { before: 50 },
                                    }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 5500,
                                  type: docx.WidthType.DXA,
                                },
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                              }),

                              // new docx.TableCell({
                              //   children: [
                              //     new Paragraph({
                              //       children: [
                              //         new TextRun({
                              //           text: "Đơn vị sử dụng",
                              //           size: 22,
                              //           bold: true,
                              //         }),
                              //       ],
                              //       alignment: docx.AlignmentType.CENTER,
                              //       border: {
                              //         bottom: {
                              //           style: BorderStyle.SINGLE,
                              //           size: 1,
                              //           color: "000000",
                              //         },
                              //       },
                              //     }),
                              //     new Paragraph({
                              //       text: item.eApprovedByITLeadDate
                              //         ? `Ngày duyệt: ${getDDMMYYYFormat(
                              //             item.eApprovedByITLeadDate
                              //           )} - ${getHHmmFormat(
                              //             item.eApprovedByITLeadDate
                              //           )}`
                              //         : "",
                              //       alignment: docx.AlignmentType.CENTER,
                              //     }),
                              //     new Paragraph({
                              //       text:
                              //         item.eApprovedByITLead &&
                              //         item.eApprovedByITLeadDate
                              //           ? item.eApprovedByITLead.split(
                              //               "|"
                              //             )[2]
                              //           : "",
                              //       alignment: docx.AlignmentType.CENTER,
                              //     }),
                              //     item.eApprovedByITLeadDate &&
                              //       new docx.Paragraph({
                              //         children: [
                              //           new ImageRun({
                              //             data: item
                              //               .eApprovedByITLeadDate
                              //               ? imageTick
                              //               : "",
                              //             transformation: {
                              //               width: 60,
                              //               height: 60,
                              //             },
                              //           }),
                              //         ],
                              //         spacing: { before: 50 },
                              //         alignment: docx.AlignmentType.CENTER,
                              //       }),
                              //     new Paragraph({
                              //       text:
                              //         item.eApprovedByITLead &&
                              //         item.eApprovedByITLeadDate
                              //           ? item.eApprovedByITLead.split(
                              //               "|"
                              //             )[1]
                              //           : "",
                              //       alignment: docx.AlignmentType.CENTER,
                              //       spacing: { before: 50 },
                              //     }),
                              //   ],
                              //   margins: TableMargins,
                              //   width: {
                              //     size: 5500,
                              //     type: docx.WidthType.DXA,
                              //   },
                              //   borders: {
                              //     top: {
                              //       style: BorderStyle.SINGLE,
                              //       size: 1,
                              //       color: "ffffff",
                              //     },
                              //     bottom: {
                              //       style: BorderStyle.SINGLE,
                              //       size: 1,
                              //       color: "ffffff",
                              //     },
                              //     right: {
                              //       style: BorderStyle.SINGLE,
                              //       size: 1,
                              //       color: "ffffff",
                              //     },
                              //   },
                              // }),
                            ],
                            height: {
                              value: 2000,
                              rule: docx.HeightRule.AUTO,
                            },
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "IV. Nghiệm thu: (Thực hiện sau khi bàn giao thiết bị sửa chữa)",
                            size: 26,
                            italics: true,
                          }),
                        ],
                      }),
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: item.eAssigneeStatusDate
                              ? "Ngày nghiệm thu: " +
                                getDDMMYYYFormat(item.eAssigneeStatusDate) +
                                " - " +
                                getHHmmFormat(item.eAssigneeStatusDate)
                              : "Ngày nghiệm thu: ",
                            size: 24,
                          }),
                        ],
                        indent: {
                          left: 100,
                        },
                      }),
                      new docx.Paragraph({
                        children: [
                          new TextRun({
                            text: "Thu hồi TS/CC tạm thời:",
                            size: 24,
                          }),
                        ],
                        indent: {
                          left: 100,
                        },
                      }),
                    ],
                    margins: TableMargins,
                  }),
                ],
              }),
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Table({
                        rows: [
                          new docx.TableRow({
                            children: [
                              new docx.TableCell({
                                children: [
                                  new Paragraph({
                                    children: [
                                      new TextRun({
                                        text: "Đơn vị sử dụng",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                    border: {
                                      bottom: {
                                        style: BorderStyle.SINGLE,
                                        size: 1,
                                        color: "000000",
                                      },
                                    },
                                  }),
                                  new Paragraph({
                                    text: item.eAssigneeStatusDate
                                      ? `Ngày thực hiện/ Bàn giao: ${getDDMMYYYFormat(
                                          item.eAssigneeStatusDate
                                        )} - ${getHHmmFormat(item.eAssigneeStatusDate)}`
                                      : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  new Paragraph({
                                    text:
                                      item.eAssignee && item.eAssigneeStatusDate
                                        ? item.eAssignee.split("|")[2]
                                        : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  item.eAssigneeStatusDate &&
                                    new docx.Paragraph({
                                      children: [
                                        new ImageRun({
                                          data: tickBase64,
                                          transformation: {
                                            width: 60,
                                            height: 60,
                                          },
                                        }),
                                      ],
                                      spacing: { before: 50 },
                                      alignment: docx.AlignmentType.CENTER,
                                    }),
                                  new Paragraph({
                                    text:
                                      item.eAssignee && item.eAssigneeStatusDate
                                        ? item.eAssignee.split("|")[1]
                                        : "",
                                    alignment: docx.AlignmentType.CENTER,
                                    spacing: { before: 50 },
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 5500,
                                  type: docx.WidthType.DXA,
                                },
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  left: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                              }),
                              new docx.TableCell({
                                children: [
                                  new Paragraph({
                                    children: [
                                      new TextRun({
                                        text: "Chuyên viên CNTT",
                                        size: 22,
                                        bold: true,
                                      }),
                                    ],
                                    alignment: docx.AlignmentType.CENTER,
                                    border: {
                                      bottom: {
                                        style: BorderStyle.SINGLE,
                                        size: 1,
                                        color: "000000",
                                      },
                                    },
                                  }),
                                  new Paragraph({
                                    text: item.eApprovedByITHeadDate
                                      ? `Ngày thực hiện/ Bàn giao: ${getDDMMYYYFormat(
                                          item.eApprovedByITHeadDate
                                        )} - ${getHHmmFormat(item.eApprovedByITHeadDate)}`
                                      : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  new Paragraph({
                                    text:
                                      item.eApprovedByITHead && item.eApprovedByITHeadDate
                                        ? item.eApprovedByITHead.split("|")[2]
                                        : "",
                                    alignment: docx.AlignmentType.CENTER,
                                  }),
                                  item.eApprovedByITHeadDate &&
                                    new docx.Paragraph({
                                      children: [
                                        new ImageRun({
                                          data: item.eApprovedByITHeadDate ? tickBase64 : "",
                                          transformation: {
                                            width: 60,
                                            height: 60,
                                          },
                                        }),
                                      ],
                                      spacing: { before: 50 },
                                      alignment: docx.AlignmentType.CENTER,
                                    }),
                                  new Paragraph({
                                    text:
                                      item.eApprovedByITHead && item.eApprovedByITHeadDate
                                        ? item.eApprovedByITHead.split("|")[1]
                                        : "",
                                    alignment: docx.AlignmentType.CENTER,
                                    spacing: { before: 50 },
                                  }),
                                ],
                                margins: TableMargins,
                                width: {
                                  size: 5500,
                                  type: docx.WidthType.DXA,
                                },
                                borders: {
                                  top: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  bottom: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                  right: {
                                    style: BorderStyle.SINGLE,
                                    size: 1,
                                    color: "ffffff",
                                  },
                                },
                              }),
                            ],
                            height: {
                              value: 2000,
                              rule: docx.HeightRule.AUTO,
                            },
                          }),
                        ],
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
          // new docx.Paragraph({
          //   children: [
          //     new TextRun({
          //       text: "Ghi chú: ",
          //       color: "000000",
          //       size: 23,
          //       bold: true
          //     }),
          //     new TextRun({
          //       text: "Thiết bị dùng chung: Cán bộ đội trở lên ký nghiệm thu; ",
          //       color: "000000",
          //       size: 19,
          //       italics: true
          //     }),
          //     new TextRun({
          //       text: "Thiết bị cá nhân: Người sử dụng ký nghiệm thu",
          //       color: "000000",
          //       size: 19,
          //       italics: true
          //     }),
          //   ],
          //   spacing: {
          //     before: 200,
          //   }
          // }),
        ],
      },
    ],
  });

  docx.Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `PhieuKiemTraVaSuaChuaCNTT_${item.id}.docx`);
    CreateNotification({
      title: "Thông báo",
      body: "Xuất phiếu kiểm tra và sửa chữa CNTT thành công",
      icon: "/icons/success.png",
    });
  });
};
